import { Skeleton, TableCell, TableRow } from '@mui/material';

type SkeletonProps = {
  driversLength?: number;
};

export const SkeletonRow = ({ driversLength = 0 }: SkeletonProps) => {
  const cellHeight = { xs: 200, md: 147 };
  return (
    <TableRow
      data-testid="skeleton-row"
      sx={{
        '& td': {
          border: 'none',
          borderBottom: '1px solid',
          borderColor: 'neutral.lighter',
          verticalAlign: 'top',
        },
      }}
    >
      <TableCell
        sx={{
          minWidth: {
            md: 190,
          },
          width: { xs: 190, md: driversLength ? 190 : 'auto' },
          paddingY: 3,
          paddingLeft: 0,
          paddingRight: 2,
          background: 'white',
          position: 'relative',
          height: cellHeight,
        }}
      >
        <Skeleton
          variant="rounded"
          sx={{
            height: '100%',
          }}
        />
      </TableCell>
      <TableCell
        sx={{
          paddingY: 3,
          paddingX: 2,
          width: 230,
          minWidth: { xs: 130 },
          height: cellHeight,
        }}
      >
        <Skeleton
          variant="rounded"
          sx={{
            height: '100%',
          }}
        />
      </TableCell>
      {Array.from({ length: driversLength }).map((_, index) => (
        <TableCell
          key={index}
          sx={{
            paddingY: 3,
            paddingX: 2,
            width: 190,
            minWidth: { xs: 130 },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            height: cellHeight,
          }}
        >
          <Skeleton
            variant="rounded"
            sx={{
              height: '100%',
            }}
          />
        </TableCell>
      ))}
      <TableCell
        sx={{
          width: 159,
          paddingY: 3,
          paddingX: 2,
          display: { xs: 'none', md: 'table-cell' },
          height: cellHeight,
        }}
      >
        <Skeleton
          variant="rounded"
          sx={{
            height: '100%',
          }}
        />
      </TableCell>
    </TableRow>
  );
};
